module.exports = __webpack_public_path__ + "media/mobile.0b9e4748.mp4";